/* unplugin-vue-components disabled */import { render } from "./BatterTableDataView.vue?vue&type=template&id=f6bee4c4"
import script from "./BatterTableDataView.vue?vue&type=script&lang=js"
export * from "./BatterTableDataView.vue?vue&type=script&lang=js"

import "./BatterTableDataView.vue?vue&type=style&index=0&id=f6bee4c4&lang=scss"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__